/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from 'mobx-react'
import { Modal, QRCode } from 'antd'
import styles from './PayModal.module.less'
import { IconImage } from '@/components/Icon/Icon'
import { uiController } from '@/controllers/uiController'
import { commonUtils } from '@/helpers/commonUtils'
import { useCallback, useEffect, useState } from 'react'
import { PayHelper } from '@/helpers/payHelper'
import { api } from '@/helpers/api'
import classNames from 'classnames'
import { debounce } from 'lodash-es'

export interface PayModalProps {
  visible: boolean
  detail: ServerData.PptData
  payHelper: PayHelper
  onPaySuccess?: () => void
  onClose: () => void
}

const RecommendList = observer(() => {
  const [list, setList] = useState<ServerData.PptData[]>([
    {} as ServerData.PptData,
    {} as ServerData.PptData,
    {} as ServerData.PptData,
  ])

  useEffect(() => {
    api.ppt
      .getPptList({
        page: 1,
        pageSize: 10,
      })
      .then((res) => {
        setList(res.dataList)
      })
  }, [])

  return (
    <div className={styles.recommendList}>
      {list.map((item, idx) => {
        return (
          <div key={`${item.id}-${idx}`} className={styles.recommendListItem}>
            <div className={styles.recommendListItemImg}>
              <img
                className={styles.img}
                src={commonUtils.getimageView(item.abbreviatePath, 240, 136)}
                alt={item.name}
              />
            </div>
            <div className={styles.recommendListItemTitle}>{item.name}</div>
          </div>
        )
      })}
    </div>
  )
})
const PayModal = observer((props: PayModalProps) => {
  const [order, setOrder] = useState<ServerData.CreateOrderData>({} as ServerData.CreateOrderData)
  const [chargeChannel, setChargeChannel] =
    useState<PostData.CreateOrderData['chargeChannel']>('wx_pub_qr')

  const createOrder = useCallback(
    debounce((chargeChannel) => {
      props.payHelper.createPayQrCode({
        planId: props.detail.planId,
        materialId: props.detail.id,
        chargeChannel: chargeChannel,
        onCreateOrder(data) {
          setOrder(data)
        },
        onPaySuccess(data) {
          props.onClose()
          props.onPaySuccess?.()
        },
      })
    }, 100),
    []
  )

  useEffect(() => {
    if (props.visible && chargeChannel) {
      createOrder(chargeChannel)
    }
  }, [props.visible, chargeChannel])

  return (
    <Modal
      open={props.visible}
      footer={null}
      closeIcon={false}
      onCancel={props.onClose}
      width={853}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: 24,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.payModal}>
        <div className={styles.modalClose} onClick={props.onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalTitle}>单独购买此模版</div>
        <div className={styles.modalContent}>
          <div className={styles.paymentBox}>
            <div className={styles.goodsCard}>
              <div className={styles.goodsCardImg}>
                <img
                  className={styles.img}
                  draggable={false}
                  src={commonUtils.getimageView(props.detail.abbreviatePath, 267, 150)}
                  alt={props.detail.name}
                />
              </div>
              <div className={styles.goodsCardTitle}>{props.detail.name}</div>
            </div>
            <div className={styles.orderInfo}>
              <div className={styles.orderInfoPrice}>
                <span className={styles.orderInfoPriceLabel}>应付：</span>
                <span className={styles.orderInfoPriceValue}>
                  ￥{commonUtils.parseCurrency(props.detail?.planData?.price || 0)}
                </span>
              </div>
              <div className={styles.orderInfoLine}></div>
              <div className={styles.orderInfoTip}>
                <IconImage width={11} height={11} src='IconCheck' /> 智能适配多场景
              </div>
              <div className={styles.orderInfoTip}>
                <IconImage width={11} height={11} src='IconCheck' /> 海量风格随心换
              </div>
              <div className={styles.orderInfoTip}>
                <IconImage width={11} height={11} src='IconCheck' /> 跨行业模板专享
              </div>
              <div className={styles.orderInfoTip}>
                <IconImage width={11} height={11} src='IconCheck' /> 直接插入PPT免调试
              </div>
            </div>
            <div className={styles.orderPayQr}>
              <div className={styles.payType}>
                <div
                  className={classNames(styles.payTypeItem, {
                    [styles.active]: chargeChannel === 'wx_pub_qr',
                  })}
                  onClick={() => setChargeChannel('wx_pub_qr')}
                >
                  <IconImage width={17} height={17} src='IconWepay_1'></IconImage>
                  微信支付
                </div>
                <div
                  className={classNames(styles.payTypeItem, {
                    [styles.active]: chargeChannel === 'alipay_qr',
                  })}
                  onClick={() => setChargeChannel('alipay_qr')}
                >
                  <IconImage width={17} height={17} src='IconAlipay_1'></IconImage>
                  支付宝支付
                </div>
              </div>
              <div className={styles.orderPayQrImg}>
                <QRCode
                  style={{ borderRadius: 6, padding: 9 }}
                  size={153}
                  bgColor='#fff'
                  color='#333'
                  value={order.codeUrl || '-'}
                  status={order.codeUrl ? 'active' : 'loading'}
                />
              </div>
            </div>
          </div>
          <RecommendList />
          <div className={styles.openVipMask}>
            <div className={styles.openVipMaskTitle}>
              <IconImage width={20} height={26} src='IconLock' />
              开通会员解锁全部模版
            </div>
            <div
              className={styles.openVipMaskBtn}
              onClick={() => {
                uiController.openVipModal(props.detail)
                uiController.payModalProps.visible = false
                props.onClose()
              }}
            >
              立即开通
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default PayModal
